import React, { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import StatementIcon from 'custom/assets/accounts/Statement.svg'
import DetailsIcon from 'custom/assets/accounts/Details.svg'
import UserIcon from 'custom/assets/common-icons/User.svg'
import CreditIcon from 'custom/assets/accounts/up_Arrow.svg'
import DebitIcon from 'custom/assets/accounts/down_arrow.svg'
import LayoutWithAccountCard from '../../../layout/Layout/layout-account-card'
import { carouselCurrentItemSelector } from '../../../selectors'
import { useTranslation } from 'react-i18next'
import {
  MENU_SIDEBAR_KEYS,
  SIDENAV_KEYS,
  LOAN_KEYS,
  ACCOUNT_KEYS,
  MENU_SIDEBAR_DETAILS_KEYS,
  DIALOG_KEYS,
  LANDING_KEYS,
} from '../../../utils/translation-constants'
import AccountsService from '../../../services/accounts.service'
import '../../../styles/statement.css'
import moment from 'moment'
import NeoLoader from '../../../components/FormComponents/NeoLoader'
import NumberFormat from 'react-number-format'
import { useHistory } from 'react-router-dom'
import NeoButton from '../../../components/NeoButton/NeoButton'
import NeoCalendar from './../../../components/NeoCalendar/NeoCalendar'
import Pagination from 'react-js-pagination'

export default function AccountStatement() {
  const history = useHistory()
  const [loader, setLoader] = useState(false)
  const [downloadLoader, setDownloadLoader] = useState(false)
  const [miniStatementList, setMiniStatementList] = useState([])
  const [detailStatementList, setDetailStatementList] = useState([])
  const [slicedDetailStatementList, setSlicedDetailStatementList] = useState([])
  const [showList, setShowList] = useState('mini') // 'mini' or 'detail' statement
  const currentAccountDetail = useSelector(carouselCurrentItemSelector)
  const [expanded, setExpanded] = useState(null)
  const [showDSbuttons, setShowDSbuttons] = useState(false)
  const [fromDate, setFromDate] = useState(null)
  const [toDate, setToDate] = useState(null)
  const [showDatePicker, setShowDatePicker] = useState(false)
  const [dateError, setDateError] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const pageLimit = 10
  const { t } = useTranslation()

  useEffect(() => {
    setShowList('mini')
    setShowDSbuttons(false)
    getMiniStatement()
  }, [currentAccountDetail])

  const getMiniStatement = useCallback(async () => {
    try {
      setLoader(true)
      const response = await AccountsService.getLast10Transactions(currentAccountDetail)
      if (response.status === 200) {
        if (response.data['miniStatement'] && response.data['miniStatement'].length > 0) {
          setMiniStatementList(response.data['miniStatement'])
        } else {
          setMiniStatementList([])
        }
        setLoader(false)
      }
    } catch (err) {
      setLoader(false)
    }
  }, [currentAccountDetail])

  const getFullStatementFor = async (months) => {
    try {
      setShowDatePicker(false)
      setLoader(true)
      setShowList('detail')
      setExpanded(null)
      let response = undefined
      setFromDate(
        moment()
          .subtract(months != 1 && months, 'month')
          .startOf('month')
          .format('YYYY-MM-DD'),
      )
      setToDate(
        moment()
          .subtract(months != 1 && 1, 'month')
          .endOf('month')
          .format('YYYY-MM-DD'),
      )

      if (months == 1) {
        response = await AccountsService.getCurrentMonthTransactions(
          currentAccountDetail.accountNo,
          currentAccountDetail.custNo,
        )
      } else if (months == 2) {
        response = await AccountsService.getLast2MonthTransactions(
          currentAccountDetail.accountNo,
          currentAccountDetail.custNo,
          months,
        )
      } else if (months == 3) {
        response = await AccountsService.getLast3MonthTransactions(
          currentAccountDetail.accountNo,
          currentAccountDetail.custNo,
          months,
        )
      }
      if (response.items != null && response.items.length) {
        const tempList = await response.items.map((value) => {
          value = {
            ...value,
            groupdate: new Date(value.date).toISOString().slice(0, 7),
          }
          return value
        })
        setDetailStatementList(tempList)
        sliceDetailedStatement(1, tempList)
        setLoader(false)
      } else {
        setDetailStatementList([])
        setLoader(false)
      }
    } catch (e) {
      setLoader(false)
    }
  }

  const getStatementForDate = async () => {
    // !: fetches statements in range of fromdate and todate
    try {
      if (!fromDate || !toDate) {
        setDateError(true)
        return
      }
      setDateError(false)
      setLoader(true)
      setShowList('detail')
      const response = await AccountsService.getTransactionsForDate({
        accountNumber: currentAccountDetail.accountNo,
        custId: currentAccountDetail.custNo,
        fromDate: fromDate,
        toDate: toDate,
      })
      if (response.items != null && response.items.length) {
        const tempList = await response.items.map((value) => {
          value = {
            ...value,
            groupdate: new Date(value.date).toISOString().slice(0, 7),
          }
          return value
        })
        setDetailStatementList(tempList)
        sliceDetailedStatement(1, tempList)
        setLoader(false)
      } else {
        setDetailStatementList([])
        setLoader(false)
      }
    } catch (e) {
      setLoader(false)
    }
  }

  const sliceDetailedStatement = useCallback(async (currentPageNo, lst) => {
    // useEffect (  () => {
    setCurrentPage(currentPageNo)
    let start = (currentPageNo - 1) * pageLimit
    let end = currentPageNo * pageLimit
    if (lst && lst.length > 0) {
      let x = lst.slice(start, end < lst.length ? end : lst.length)
      setExpanded(null)
      setSlicedDetailStatementList(x)
    } else {
    }
  }, []) //currentPage

  const downloadStatement = async (data) => {
    try {
      setDownloadLoader(true)
      let fdate = new Date(fromDate).toISOString().split('T')[0]
      let tdate = new Date(toDate).toISOString().split('T')[0]
      await AccountsService.getPDFStatement(fdate, tdate, currentAccountDetail.custNo, data)
      setDownloadLoader(false)
    } catch (err) {
      setDownloadLoader(false)
    }
  }

  return (
    <LayoutWithAccountCard breadCumKey='STATEMENTS'>
      <div>
        <div className='row'>
          <div className='col-7 d-flex'>
            <div>
              <img src={StatementIcon} alt='statement icon' /> &nbsp;
            </div>
            <div className='title-spacing'>
              <span className='font-weight-bold'>{t(MENU_SIDEBAR_KEYS.STATEMENT)}</span>
              <span className='header-title-section'>
                <p>{t(MENU_SIDEBAR_DETAILS_KEYS.STATEMENT)}</p>
              </span>
            </div>
          </div>
          <div className='col-5 text-right'>
            <button
              type='button'
              className='btn p-2 detailed-statement-btn'
              onClick={() => {
                history.push('/detailed-statement')
              }}>
              <img src={DetailsIcon} alt='' className='mr-2' height={23} width={20} />
              <span className='font-weight-600'>{t(MENU_SIDEBAR_KEYS.DETAILED_STATEMENT)}</span>
            </button>
          </div>
        </div>
        {/* {showDSbuttons && (
          <div className='row mb-4'>
            <div className='col-4'>
              <button
                type='button'
                className='btn p-2 detailed-statement-btn w-100 mb-3'
                onClick={() => getFullStatementFor(1)}>
                <img src={DetailsIcon} height={23} width={20} alt='' className='mr-2' />
                <span className='font-weight-600'>{t(MENU_SIDEBAR_KEYS.CURRENTMOONTH)}</span>
              </button>
            </div>
            <div className='col-4'>
              <button
                type='button'
                className='btn p-2 detailed-statement-btn w-100 mb-3'
                onClick={() => getFullStatementFor(2)}>
                <img src={DetailsIcon} height={23} width={20} alt='' className='mr-2' />
                <span className='font-weight-600'>{t(MENU_SIDEBAR_KEYS.LASTTWOMONTH)}</span>
              </button>
            </div>
            <div className='col-4'>
              <button
                type='button'
                className='btn p-2 detailed-statement-btn w-100 mb-3'
                onClick={() => getFullStatementFor(3)}>
                <img src={DetailsIcon} height={23} width={20} alt='' className='mr-2' />
                <span className='font-weight-600'>{t(MENU_SIDEBAR_KEYS.LASTTHREEMONTH)}</span>
              </button>
            </div>
            <div className='col-4'>
              <button
                type='button'
                className='btn p-2 detailed-statement-btn w-100'
                onClick={() => setShowDatePicker(!showDatePicker)}>
                <img src={DetailsIcon} height={23} width={20} alt='' className='mr-2' />
                <span className='font-weight-600'>{t(MENU_SIDEBAR_KEYS.CUSTOMDATES)}</span>
              </button>
            </div>

            {showDatePicker && (
              <div className='col-12 text-center m-3 calender-container'>
                <NeoCalendar setFromDate={setFromDate} setToDate={setToDate} />
                <div>
                  <NeoButton
                    type='button'
                    mode='newDesign'
                    text={'Ok'}
                    styles={{ fontSize: 14, width: '247px' }}
                    onClick={() => {
                      getStatementForDate({ fromDate, toDate })
                      setShowDatePicker(false)
                    }}
                  />

                  {dateError && (
                    <div className='text-danger'>
                      {!fromDate && !toDate && 'Please select the first day.'}
                      {fromDate && !toDate && 'Please select the last day.'}
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        )} */}
        <div>
          {loader && <NeoLoader />}

          {/* // ! mini statement list start */}
          {!loader && showList == 'mini' && !miniStatementList.length && (
            <div className='text-center'>{t(DIALOG_KEYS.NO_TRANSACTION)}</div>
          )}

          {!loader &&
            showList == 'mini' &&
            miniStatementList.map((stmnt, i) => (
              <div key={i} className='statement-item'>
                <div
                  className='d-flex justify-content-between font-weight-600'
                  onClick={() => (expanded == i ? setExpanded(null) : setExpanded(i))}>
                  <div className='d-flex'>
                    <div className='mr-3'>
                      <img src={UserIcon} alt='user icon' className='user-icon p-2' />
                    </div>
                    <div>
                      <div className='statement-desc'>{stmnt.txnTypeDes}</div>
                      <div className='statement-date-time'>
                        {moment(stmnt.date).format('DD-MM-YYYY')}
                      </div>
                    </div>
                  </div>
                  <div className='text-right'>
                    <div
                      style={
                        stmnt.debitOrCredit == 'Debit' ? { color: 'red' } : { color: '#1fa01f' }
                      }>
                      <span className='statement-currency mr-1'>{stmnt.txnCurrency}</span>
                      <span className='statement-amount'>
                        <NumberFormat
                          value={stmnt?.amount}
                          displayType={'text'}
                          thousandSeparator={true}
                          prefix={''}
                          fixedDecimalScale={true}
                          decimalScale={2}
                          allowEmptyFormatting
                        />
                      </span>
                      {stmnt.debitOrCredit == 'Debit' ? (
                        <img width='10px' style={{ marginLeft: 3 }} src={CreditIcon} alt='' />
                      ) : (
                        <img width='10px' style={{ marginLeft: 3 }} src={DebitIcon} alt='' />
                      )}
                    </div>
                  </div>
                </div>
                {expanded == i && (
                  <div className='ml-2 mt-3'>
                    <div className='row my-2'>
                      <div className='col-4'>
                        <div className='statement-expanded-label font-weight-500'>
                          {t(ACCOUNT_KEYS.TRANSACTION_DETAILS_KEYS.REF)}
                        </div>
                        <div className='statement-expanded-value font-weight-bold'>
                          {stmnt.refNo}
                        </div>
                      </div>
                      <div className='col-4'>
                        <div className='statement-expanded-label font-weight-500'>
                          {t(ACCOUNT_KEYS.TRANSACTION_DETAILS_KEYS.currency)}
                        </div>
                        <div className='statement-expanded-value font-weight-bold'>
                          {stmnt.txnCurrency || '-'}
                        </div>
                      </div>
                      <div className='col-4'>
                        <div className='statement-expanded-label font-weight-500'>
                          {t(ACCOUNT_KEYS.TRANSACTION_DETAILS_KEYS.AMOUNT)}
                        </div>
                        <div className='statement-expanded-value font-weight-bold'>
                          <NumberFormat
                            value={stmnt?.amount}
                            displayType={'text'}
                            thousandSeparator={true}
                            prefix={''}
                            fixedDecimalScale={true}
                            decimalScale={2}
                            allowEmptyFormatting
                          />
                        </div>
                      </div>
                    </div>
                    <div className='row my-2'>
                      <div className='col-4'>
                        <div className='statement-expanded-label font-weight-500'>
                          {t(ACCOUNT_KEYS.TRANSACTION_DETAILS_KEYS.TXN_TYPE)}
                        </div>
                        <div className='statement-expanded-value font-weight-bold'>
                          {stmnt.txnTypeDes}
                        </div>
                      </div>
                      <div className='col-4'>
                        <div className='statement-expanded-label font-weight-500'>
                          {t(ACCOUNT_KEYS.TRANSACTION_DETAILS_KEYS.DATE)}
                        </div>
                        <div className='statement-expanded-value font-weight-bold'>
                          {moment(stmnt.date).format('ddd MMM DD YYYY')}
                        </div>
                      </div>
                      <div className='col-4'>
                        <div className='statement-expanded-label font-weight-500'>
                          {t(ACCOUNT_KEYS.TRANSACTION_DETAILS_KEYS.DEBIT_CREDIT)}
                        </div>
                        <div className='statement-expanded-value font-weight-bold'>
                          {stmnt.debitOrCredit}
                        </div>
                      </div>
                    </div>
                    <div className='row my-2'>
                      <div className='col-12'>
                        <div className='statement-expanded-label font-weight-500'>
                          {t(ACCOUNT_KEYS.TRANSACTION_DETAILS_KEYS.REMARK)}
                        </div>
                        <div className='statement-expanded-value font-weight-bold'>
                          {stmnt.narration || '---'}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ))}
        </div>
        {/* // ! mini statement list end */}

        {/* // ! detail statement list start */}
        {/* {!loader && showList == 'detail' && !detailStatementList.length && (
            <div className='text-center'>No Transactions Found</div>
          )}
          {!loader &&
            showList == 'detail' &&
            detailStatementList &&
            detailStatementList.length > 0 && (
              <React.Fragment>
                <div className='d-flex justify-content-between pt-4'>
                  <div className='statement-list-title font-weight-bold'>
                    {new Date(fromDate).toLocaleString('default', { month: 'long' })}
                    {new Date(fromDate).getMonth() != new Date(toDate).getMonth() &&
                      `-${new Date(toDate).toLocaleString('default', { month: 'long' })}`}
                    {' Statement'}
                  </div>
                  <button
                    type='button'
                    className='btn btn-sm bg-white mx-1 font-weight-bold rounded-2'
                    disabled
                    style={{ fontSize: 10 }}
                    onClick={() => downloadStatement()}
                    disabled={detailStatementList.length === 0}>
                    {downloadLoader ? (
                      <NeoLoader width={'10px'} height={'10px'} text='Downloading' />
                    ) : (
                      'Download Statement'
                    )}
                  </button>
                </div>
                {slicedDetailStatementList.length &&
                  slicedDetailStatementList.map((stmnt, i) => (
                    <div key={i}>
                      {(i === 0 ||
                        (i > 0 &&
                          stmnt.groupdate !== slicedDetailStatementList[i - 1].groupdate)) && (
                        <div className='font-weight-600' style={{ fontSize: 8 }}>
                          {new Date(stmnt.groupdate).toLocaleString('default', { month: 'long' })}
                          {' ' + new Date(stmnt.groupdate).getFullYear()}
                        </div>
                      )}
                      <div key={i} className='statement-item'>
                        <div
                          className='d-flex justify-content-between font-weight-600'
                          onClick={() => (expanded == i ? setExpanded(null) : setExpanded(i))}>
                          <div className='d-flex'>
                            <div className='mr-3'>
                              <img src={UserIcon} alt='user icon' className='user-icon p-2' />
                            </div>
                            <div>
                              <div className='statement-desc'>{stmnt.txnTypeDes}</div>
                              <div className='statement-date-time'>
                                {moment(stmnt.date).format('DD-MM-YYYY')}
                              </div>
                            </div>
                          </div>
                          <div className='text-right'>
                            <div>
                              <span className='statement-currency mr-1'>{stmnt.txncurrency}</span>
                              <span className='statement-amount'>
                                <NumberFormat
                                  value={stmnt.amount}
                                  displayType={'text'}
                                  thousandSeparator={true}
                                  prefix={''}
                                />
                              </span>
                              {stmnt.debitOrCredit == 'Debit' ? (
                                <img src={DebitIcon} alt='' />
                              ) : (
                                <img
                                  src={CreditIcon}
                                  alt=''
                                  style={{ transform: 'rotateZ(180deg)' }}
                                />
                              )}
                            </div>
                            <div className='statement-date-time'>
                              {new Date().getHours() + ':' + new Date().getMinutes()}
                            </div>
                          </div>
                        </div>

                        {expanded == i && (
                          <div className='ml-2 mt-3'>
                            <div className='row my-2'>
                              <div className='col-4'>
                                <div className='statement-expanded-label font-weight-500'>
                                {t(ACCOUNT_KEYS.TRANSACTION_DETAILS_KEYS.REF)}
                                </div>
                                <div className='statement-expanded-value font-weight-bold'>
                                  {stmnt.refNo || '-'}
                                </div>
                              </div>
                              <div className='col-4'>
                                <div className='statement-expanded-label font-weight-500'>
                                {t(ACCOUNT_KEYS.EXPENSE_KEYS.NARRATION)}
                                </div>
                                <div className='statement-expanded-value font-weight-bold'>
                                  {stmnt.narration || '-'}
                                </div>
                              </div>
                              <div className='col-4'>
                                <div className='statement-expanded-label font-weight-500'>
                                {t(ACCOUNT_KEYS.EXPENSE_KEYS.INSTRUMENT_CODE)}
                                </div>
                                <div className='statement-expanded-value font-weight-bold'>
                                  {stmnt.instrumentCode || '-'}
                                </div>
                              </div>
                              <div className='col-4'>
                                <div className='statement-expanded-label font-weight-500'>
                                {t(ACCOUNT_KEYS.EXPENSE_KEYS.SERIAL_NUMBER)}
                                </div>
                                <div className='statement-expanded-value font-weight-bold'>
                                  {stmnt.slNo || '-'}
                                </div>
                              </div>
                              <div className='col-4'>
                                <div className='statement-expanded-label font-weight-500'>
                                {t(ACCOUNT_KEYS.TRANSACTION_DETAILS_KEYS.DEBIT_CREDIT)}
                                </div>
                                <div className='statement-expanded-value font-weight-bold'>
                                  {stmnt.debitOrCredit || '-'}
                                </div>
                              </div>
                              <div className='col-4'>
                                <div className='statement-expanded-label font-weight-500'>
                                {t(ACCOUNT_KEYS.TRANSACTION_DETAILS_KEYS.BRANCH)}
                                </div>
                                <div className='statement-expanded-value font-weight-bold'>
                                  {stmnt.branch || '-'}
                                </div>
                              </div>
                              <div className='col-4'>
                                <div className='statement-expanded-label font-weight-500'>
                                {t(ACCOUNT_KEYS.TRANSACTION_DETAILS_KEYS.TXN_TYPE)}
                                </div>
                                <div className='statement-expanded-value font-weight-bold'>
                                  {stmnt.txnTypeDes || '-'}
                                </div>
                              </div>
                              <div className='col-4'>
                                <div className='statement-expanded-label font-weight-500'>
                                {t(ACCOUNT_KEYS.TRANSACTION_DETAILS_KEYS.DATE)}
                                </div>
                                <div className='statement-expanded-value font-weight-bold'>
                                  {stmnt.date || '-'}
                                </div>
                              </div>
                            </div>
                            <div className='row my-2'>
                              <div className='col-12'>
                                <div className='statement-expanded-label font-weight-500'>
                                {t(ACCOUNT_KEYS.TRANSACTION_DETAILS_KEYS.REMARK)}
                                </div>
                                <div className='statement-expanded-value font-weight-bold'>
                                  {stmnt.remarks || '---'}
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  ))}

                <div className='d-flex justify-content-center mb-5 mt-2'>
                  <Pagination
                    activePage={currentPage}
                    itemsCountPerPage={10}
                    totalItemsCount={detailStatementList.length}
                    pageRangeDisplayed={5}
                    itemClass='page-item'
                    linkClass='page-link'
                    onChange={(page) => sliceDetailedStatement(page, detailStatementList)}
                  />
                </div>
              </React.Fragment>
            )} */}
        {/* // ! detail statement list end */}
      </div>
    </LayoutWithAccountCard>
  )
}
